import { render } from "./HandleRoomsSlot.vue?vue&type=template&id=0589bbfc"
import script from "./HandleRoomsSlot.vue?vue&type=script&lang=js"
export * from "./HandleRoomsSlot.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__